// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/navigation/tree/recycle-bin/recycle-bin.component.css
// module id = 530
// module chunks = 0